import React from "react";
import { connect } from "react-redux";

// Import individual report components
import AssetAllocationReport from "../report/AssetAllocationReport";
import AssetReturnReport from "../report/AssetReturnReport";
import AssetMovementReport from "../report/AssetMovementReport";
import AssetDisposalReport from "../report/AssetDisposalReport";
import MaintenanceReport from "../report/MaintenanceReport";
import DepreciationReport from "../report/DepreciationReport";
import VendorWiseReport from "../report/VendorWiseReport";
import EmployeeAssetReport from "../report/EmployeeAssetReport";
import AssetLifecycleHistoryReport from "./AssetLifecycleHistoryReport";
import AssetLocationDepartmentReport from "./AssetLocationDepartmentReport"
import AssetEndOfLifeReport from "./AssetEndOfLifeReport";

const ReportPage = ({ reportType }) => {
  const viewReport = () => {
    switch (reportType?.value) {
      case "asset_allocation":
        return <AssetAllocationReport showHeader={false} />;
      case "asset_return":
        return <AssetReturnReport showHeader={false} />;
      case "asset_movement":
        return <AssetMovementReport showHeader={false} />;
      case "asset_disposal":
        return <AssetDisposalReport showHeader={false} />;
      case "maintenance":
        return <MaintenanceReport showHeader={false} />;
      case "depreciation":
        return <DepreciationReport showHeader={false} />;
      case "vendor_wise":
        return <VendorWiseReport showHeader={false} />;
      case "employee_asset":
        return <EmployeeAssetReport showHeader={false} />;
      case "asset_lifecycle":
        return <AssetLifecycleHistoryReport showHeader={false} />;
      case "asset_loc_dep":
        return <AssetLocationDepartmentReport showHeader={false} />;
      case "asset_end_of_life":
        return <AssetEndOfLifeReport showHeader={false} />;    
      default:
        return (
          <div className="text-center mt-4">
            Select a report from the dropdown
          </div>
        );
    }
  };

  return (
    <div className="p-0">
        
        
        {viewReport()}
    </div>
  );
};

const mapStateToProps = (state) => ({
  reportType: state.auth.reportType,
});

export default connect(mapStateToProps)(ReportPage);